
@if (point()) {
  <article 
    class="points__point"
    [class.points__point--to-delete]="isPointToDelete()"
    [class.points__point--to-replace]="isPointToReplace()"
    [class.points__point--to-add]="isPointToAddNew()"
  >
    <app-header 
      [indexCard]="indexCard()"
      [point]="point()" 
    />
    
    <app-main [point]="point()" />

    <app-footer />
  </article>
}